import './index.styl';
import { CoreLeagueJoinView } from '../../../../../core/views';
import EmptyJoinCompRowView from '../EmptyJoinLeagueRow';
import { redirectTo } from '../../../utils';
import CompJoinRowView from './CompJoinRow';

/**
 * @desc Comps Join View Class
 * This class using on league loin page ('/comps/join')
 */
export default class CompsJoinView extends CoreLeagueJoinView {
	get className() {
		return "league-table comps-join-page";
	}

	get leaguesLimit() {
		return 10;
	}

	get emptyView() {
		return EmptyJoinCompRowView;
	}

	get childView() {
		return CompJoinRowView;
	}

	get childViewOptions() {
		return {
			...super.childViewOptions,
			rounds: this.rounds
		}
	}

	/**
	 *
	 */
	joinLeagueSuccess( response ) {
		let league_id = response.id;

		let url = `/comps/${league_id}/manage`;
		redirectTo( url );
	}
}